import React from "react";
import Draggable from "react-draggable";
import { DropZone } from "../../core";
class Draggables extends React.Component {
  handleClick = () => {
    // this.props.onClose();
  };
  handleDrag = () => {
    console.log("hiiiiii");
    // this.props.onClose();
  };
  render() {
    return (
      <div
        style={{
          position: "absolute",
          top: "100px",
          left: "100px",
          zIndex: 9999,
        }}
      >
        <Draggable
          axis="both"
          handle=".handle"
          defaultPosition={{ x: 0, y: 0 }}
          position={null}
          grid={[25, 25]}
          scale={1}
          onStart={this.handleStart}
          onDrag={this.handleDrag}
          onStop={this.handleStop}
        >
          <div style={draggableStyle}>
            <div
              className="handle"
              style={handleStyle}
              onClick={this.handleClick}
              onDragStart={this.handleDrag}
            >
              Drag from here
            </div>
            <div style={{ padding: "10px" }}>
              <img
                src="https://dev-cmsautomations.s3.amazonaws.com/assets/web-version/aa283573-2d7f-40c2-90b2-0cf2b347f23d-web.jpg"
                alt="Draggable Image"
                style={imageStyle}
              />
            </div>
          </div>
        </Draggable>
      </div>
    );
  }
}

const draggableStyle = {
  width: "200px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  background: "#f9f9f9",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  cursor: "grab",
};

const handleStyle = {
  background: "#007bff",
  color: "#fff",
  padding: "8px",
  borderRadius: "4px 4px 0 0",
  textAlign: "center",
  cursor: "move",
};

const imageStyle = {
  width: "100%",
  height: "auto",
  borderRadius: "4px",
  marginBottom: "10px",
};

export default Draggables;
